import { createContext } from "react";

export const HoverContext = createContext<{
  hovering: boolean;
  setHovering(hovering: boolean): void;
}>({
  hovering: false,
  setHovering: () => undefined,
});
